import { render, staticRenderFns } from "./UnpaidBills.vue?vue&type=template&id=708acdf7&scoped=true"
import script from "./UnpaidBills.vue?vue&type=script&lang=js"
export * from "./UnpaidBills.vue?vue&type=script&lang=js"
import style0 from "./UnpaidBills.vue?vue&type=style&index=0&id=708acdf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708acdf7",
  null
  
)

export default component.exports